const BLOCKS_PARAGRAPH_SECTION = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
    id
    type
    uuid
    ... on Blocks {
      id
      button {
        title
        url
      }
      dek
      heading
      icon
      type
      uuid
      title
    }
  }
`;

export default BLOCKS_PARAGRAPH_SECTION;
